import { NotFoundIcon } from 'components/Icon';

import styles from './EventNotFound.module.scss';

const EventNotFound = () => (
  <div className={styles.container}>
    <NotFoundIcon />
    <h3>Event is not found</h3>
    <p>Please check the event one more time</p>
  </div>
);

export default EventNotFound;
